import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateDeskExternalAccountingSystemSettingsRequest extends BaseUpdateRequest {
    externalAccountingSystemShiftHoursAccount = '';
    externalAccountingSystemTravelHoursAccount = '';
    externalAccountingSystemDistanceAccount = '';
    externalAccountingSystemPlacementAccount = '';
    externalAccountingSystemShiftHoursCategory1 = '';
    externalAccountingSystemTravelHoursCategory1 = '';
    externalAccountingSystemDistanceCategory1 = '';
    externalAccountingSystemPlacementCategory1 = '';
    externalAccountingSystemShiftHoursCategory2 = '';
    externalAccountingSystemTravelHoursCategory2 = '';
    externalAccountingSystemDistanceCategory2 = '';
    externalAccountingSystemPlacementCategory2 = '';
}
